<template>
  <div>
    <component :is="tour_to_actually_show"
               @stopShowingThisTour="stopShowingThisTour"
    >

    </component>
  </div>
</template>

<script>
import AssetsWithDataTour from "./AssetsWithDataTour";
import AssetsBlankTour from "./AssetsBlankTour";

export default {
  name: "TourManager",
  props: ['tour'],
  components: {
    AssetsWithDataTour: AssetsWithDataTour,
    AssetsBlankTour: AssetsBlankTour,
  },
  data() {
    return {
      tour_to_actually_show: null,
    }
  },
  watch: {
    tour: function () {
      this.reset_tour()
    },
  },
  mounted() {
    this.reset_tour()
  },
  methods: {
    reset_tour() {
      if (window.chimera.show_tour) {
        let visited = []
        if (window.chimera.completed_tours) {
          visited = window.chimera.completed_tours.split(',')
        }
        if (this.tour) {
          if (visited.indexOf(this.tour) > -1) {
            this.tour_to_actually_show = null
          } else {
            this.tour_to_actually_show = this.tour
          }
        } else {
          this.tour_to_actually_show = null
        }
      }
    },
    stopShowingThisTour() {
      console.log('stop showing ' + this.tour_to_actually_show)
      axios.post('/stop_showing_this_tour/' + this.tour_to_actually_show)
          .then(response => {
            // console.log("just completed flattening")
            console.log('successfully stopped')
            // console.log('About to get dispositions')
          })
          .catch(error => {
            console.log('did not successfully stop')
          })
    }
  }
}
</script>

<style scoped>

</style>